/*
 * Jira Ticket:
 * Created Date: Thu, 11th Jun 2020, 10:23:01 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { Datagrid, List, TextField, usePermissions, Title } from 'react-admin';
import { AccessDenied } from 'Layout';
import ListActions from './actions';
import { isSuperAdmin } from 'utils/roles';
import { PostPagination } from '../../Components/CustomPagination/pagination';

const TemplateList = props => {
  const { permissions } = usePermissions();
  return isSuperAdmin(permissions) ? (
    <>
      <Title title={`resources.General.cmsTitle`} />
      <List
        bulkActionButtons={false}
        pagination={<PostPagination />}
        perPage={25}
        actions={<ListActions />}
        {...props}
      >
        <Datagrid rowClick="edit">
          <TextField
            source="name"
            label="resources.Template.fields.name"
            sortable={false}
          />
        </Datagrid>
      </List>
    </>
  ) : (
    <AccessDenied />
  );
};

export default TemplateList;
